import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel";
import { TvvStandaardRoute } from "@/entities/tvv";
import { useBestelTVVRoutes } from "@/features/tvv/components/regievoerder/bestel-routes-context.ts";
import { RouteBewerkenDialog } from "@/features/tvv/components/regievoerder/route-bewerken";
import { Button, Empty, EmptyDescription, EmptyHeader, EmptyImage, EmptyTitle } from "@/shared/components/ui";
import { useState } from "react";
import { useNavigate } from "react-router";
import { RouteSelectItem } from "../../shared/route-select-item.tsx";

type RoutesSelecterenViewProps = {
    dossierId: string;
    hasOrders: boolean;
};

export function RoutesSelecterenView({ dossierId, hasOrders }: Readonly<RoutesSelecterenViewProps>) {
    const { setMode } = useBestelTVVRoutes();
    const navigate = useNavigate();

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader
                section="Tvv"
                title="Selecteer routes"
                showBackButton
                onBackClick={() => (hasOrders ? setMode("overzicht") : void navigate(`/dossier/${dossierId}`))}
            />
            <DossierDetailsContent className="space-y-4">
                <RoutesContent />
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}

function RoutesContent() {
    const { toggleSelectedRoute, selectedRoutes, availableRoutes, isSelected, setMode, makeRouteAvailable } = useBestelTVVRoutes();
    const [nieuweRouteOpen, setNieuweRouteOpen] = useState(false);

    const numSelectedRoutes = selectedRoutes.length;

    const handleNieuweRouteApply = (route: TvvStandaardRoute) => {
        makeRouteAvailable(route, true);
    };

    return (
        <>
            {!availableRoutes?.length ? (
                <Empty>
                    <EmptyHeader>
                        <EmptyImage />
                        <EmptyTitle>Geen routes gevonden</EmptyTitle>
                        <EmptyDescription>Er zijn geen routes beschikbaar voor dit traject.</EmptyDescription>
                    </EmptyHeader>
                </Empty>
            ) : (
                <ul role="listbox" aria-multiselectable="true" className="flex flex-col gap-2">
                    {availableRoutes.map((route) => (
                        <RouteSelectItem
                            key={route.routeId}
                            type="checkbox"
                            route={route}
                            isSelected={isSelected(route.routeId)}
                            onToggle={() => toggleSelectedRoute(route.routeId)}
                        />
                    ))}
                </ul>
            )}
            <RouteToolbar
                onNaarBestellen={() => setMode("bestellen")}
                numSelectedRoutes={numSelectedRoutes}
                onZoekRoute={() => setMode("zoeken")}
                onNieuweRoute={() => setNieuweRouteOpen(true)}
            />
            <RouteBewerkenDialog open={nieuweRouteOpen} onOpenChange={setNieuweRouteOpen} route={null} onApply={handleNieuweRouteApply} />
        </>
    );
}

type RouteToolbarProps = {
    onNaarBestellen: () => void;
    onZoekRoute: () => void;
    onNieuweRoute: () => void;
    numSelectedRoutes: number;
};

function RouteToolbar({ numSelectedRoutes, onNaarBestellen, onZoekRoute, onNieuweRoute }: Readonly<RouteToolbarProps>) {
    return (
        <div className="flex items-center justify-between">
            <Button variant="primary" onClick={onNaarBestellen} disabled={numSelectedRoutes === 0}>
                Naar bestellen
            </Button>
            <div className="flex gap-2">
                <Button variant="secondary" icon="search" onClick={onZoekRoute}>
                    Zoek route
                </Button>
                <Button variant="secondary" icon="plus" onClick={onNieuweRoute}>
                    Nieuwe route
                </Button>
            </div>
        </div>
    );
}
